import { useState } from "react";
import { Loader2 } from "lucide-react";
import { adminApi, formatError } from "@/lib/adminApi";
import { Mark } from "@/components/Mark";

export const AdminLogin = ({ onDone }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      onDone(await adminApi.login(email, password));
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto flex min-h-[80vh] max-w-md flex-col justify-center px-6 pt-28">
      <Mark className="h-12 w-auto" />
      <h1 className="mt-6 font-display text-5xl">Admin</h1>
      <p className="mt-2 text-sm text-[#b4b2ad]">Instagram post approvals for Jaisun House.</p>
      <form data-testid="admin-login-form" onSubmit={submit} className="mt-10 space-y-6">
        <input data-testid="admin-email" type="email" required className="field" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="admin-password" type="password" required className="field" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="flex items-center gap-2 rounded-full bg-[#c8a97e] px-7 py-3.5 text-[13px] font-medium uppercase tracking-[0.16em] text-[#0a0b0d] disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
};
